/**
 * WebSocket configuration and utilities
 */

// Get WebSocket URL from environment or construct from API URL
const getWebSocketURL = () => {
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

    // Convert HTTP URL to WebSocket URL
    // http://athernor.hopto.org:25565/api -> ws://athernor.hopto.org:25565/ws/updates/
    // https://athernor.hopto.org:25565/api -> wss://athernor.hopto.org:25565/ws/updates/

    const url = new URL(apiUrl);
    const protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
    const wsUrl = `${protocol}//${url.host}/ws/updates/`;

    return wsUrl;
};

export const WS_URL = getWebSocketURL();

/**
 * WebSocket event types
 */
export const WS_EVENT_TYPES = {
    CONNECTION_ESTABLISHED: 'connection_established',
    CARD_UPDATE: 'card_update',
    DATE_UPDATE: 'date_update',
    EXPEDITION_COMPLETED: 'expedition_completed',
    COMPETITION_REWARDS: 'competition_rewards',
    COMPETITION_PHASE_CHANGE: 'competition_phase_change',
    TRADE_PROPOSAL: 'trade_proposal',
    NOTIFICATION: 'notification',
    PING: 'ping',
    PONG: 'pong',
};

/**
 * WebSocket connection states
 */
export const WS_READY_STATES = {
    CONNECTING: 0,
    OPEN: 1,
    CLOSING: 2,
    CLOSED: 3,
};

export default {
    WS_URL,
    WS_EVENT_TYPES,
    WS_READY_STATES,
};
